<template>
  <div v-if="result" class="stocks-card">
    <div class="stocks-card__image" :style="getPicture()">
      <!--            <img src="/local/templates/love-you/images/sale-card-decoration.png" alt="">-->
      <!--            <img v-if="result.picture" :src="result.picture.src" :alt="result.picture.alt">-->
    </div>
    <div class="stocks-card__inform">
      <h3 v-if="result.name" class="def-title-3">{{ result.name }}</h3>
      <div class="stocks-card__days">
        <p v-if="result.daysLeft" class="stocks-card__left">{{ result.daysLeft }}</p>

        <p v-if="result.remainingTime >= 86400000" class="stocks-card__day">{{ result.day }}</p>
        <TimeRemaining v-else :result="result" :messages="messages" />
      </div>

      <a
        v-if="result.detailPage && messages.detailText"
        :href="result.detailPage"
        class="def-button"
        :class="{ 'stocks-card__over-button': result.over }"
      >
        {{ messages.detailText }}
      </a>
    </div>
  </div>
</template>

<script>
import TimeRemaining from '@components/bootstrap/TimeRemaining.vue';

export default {
  name: 'StocksCard',
  components: { TimeRemaining },
  props: {
    result: {
      type: Object,
    },
    messages: {
      type: Object,
    },
  },
  data() {
    if (this.result.over !== false) {
      this.result.dayStamp *= 1000;
      if (this.result.dayStamp < Date.now()) {
        this.result.over = false;
        this.result.daysLeft = false;
      } else {
        this.result.day = Math.round((this.result.dayStamp - Date.now()) / 86400000);
        this.result.hoursLeft = Math.round((this.result.dayStamp - Date.now()) / (1000 * 60 * 60));
        this.result.day = `${this.result.day} ${this.num2word(
          this.result.day,
          this.messages.deyVariants
        )}`;
      }
    }
    return this.result;
  },
  computed: {},
  mounted() {
    if (parseInt(this.result.endTime) == this.result.endTime) {
      var deadline = new Date(this.result.endTime * 1000);
    } else {
      var deadline = new Date(Date.parse(this.result.endTime));
    }

    this.remainingTime = this.getTimeRemaining(deadline);
    this.interval = setInterval(() => {
      this.remainingTime = this.getTimeRemaining(deadline);
      if (this.remainingTime === 0) {
        this.$parent.updateItems(window.location.href);
        clearInterval(this.interval);
      }
    }, 1000);
  },
  methods: {
    getPicture() {
      try {
        const { picture } = this.result;
        let { src } = this.result.picture.desktop;
        if (window.innerWidth < 576 && picture.mobile && picture.mobile.src) {
          src = picture.mobile.src;
        }
        // else if (window.innerWidth >= 576 && window.innerWidth < 768 && picture.table && picture.table.src) {
        //     src = picture.table.src;
        // }
        // console.log(window.innerWidth >= 768, window.innerWidth < 992, picture);
        return `background-image: url('${src}')`;
      } catch (err) {
        console.error(err);
      }
    },
    num2word(num, words) {
      num %= 100;
      if (num > 19) num %= 10;
      switch (num) {
        case 1: {
          return words[0];
        }
        case 2:
        case 3:
        case 4: {
          return words[1];
        }
        default: {
          return words[2];
        }
      }
    },
    getTimeRemaining(endtime) {
      return Date.parse(endtime) - Date.parse(new Date());
    },
  },
};
</script>

<style lang="scss" scoped>
.stocks-card {
  display: grid;
  grid-template-columns: 1fr;
  overflow: hidden;
  //filter: drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.1));
  //overflow: hidden;
  @include point-md {
    grid-template-columns: auto 310px;
  }
  @include point-lg {
    grid-template-columns: auto 446px;
  }
  &__inform {
    display: flex;
    flex-direction: column;
    padding: 20px;
    background-color: #fff;
    //filter: drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.1));
    @include point-md {
      padding: 40px;
    }
    @include point-lg {
      padding: 48px;
    }
  }
  &__days {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;
  }
  &__image {
    height: 282px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
    z-index: 1;
    //filter: drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.1));
    @include point-sm {
      height: 100%;
      height: 282px;
    }
    img {
      display: block;
      max-width: 100%;
    }
    &:after {
      content: '';
      display: block;
      width: 48px;
      height: 48px;
      background-color: #f7f8f9;
      position: absolute;
      bottom: 0;
      transform: translate(-50%, 50%);
      border-radius: 50%;
      z-index: 1;
      @include point-md {
        width: 64px;
        height: 32px;
        right: 0;
        transform: translate(50%, 0%);
        bottom: unset;
        border-radius: 0 0 50% 50% / 0 0 100% 100%;
      }
    }
    &:before {
      content: '';
      display: block;
      width: 48px;
      height: 48px;
      background-color: #f7f8f9;
      position: absolute;
      right: 0;
      bottom: 0;
      transform: translate(50%, 50%);
      border-radius: 50%;
      @include point-md {
        width: 64px;
        height: 32px;
        transform: translate(50%);
        border-radius: 50% 50% 0 0 / 100% 100% 0 0;
      }
    }
  }
  &__left {
    font-weight: 500;
    font-size: rem(12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #000000;
  }
  &__day {
    font-weight: 700;
    font-size: rem(24);
    color: var(--text-colour-primary);
    @include point-lg {
      font-size: rem(32);
    }
    @include point-lg {
      font-size: rem(40);
    }
  }
  .def-button {
    margin-top: auto;
    background-color: var(--background-colour-primary);
    color: var(--text-colour-secondary);
    font-size: rem(12);
    @include point-md {
      font-size: rem(14);
    }
    &:hover {
      color: var(--text-colour-secondary);
    }
  }
  .def-title-3 {
    font-size: rem(16);
    margin-bottom: 16px;
    @include point-md {
      font-size: rem(18);
    }
    @include point-lg {
      font-size: rem(24);
    }
  }
  &__over-button.def-button {
    background-color: #e4e4e4;
    color: #a8a6a6;
  }
}
</style>
